<template>
    <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
        <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
            <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
        </parallax>

        <div>
            <h1 style="color: white;">{{ $t('common.registration') }}</h1>
            <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
        </div>

        <b-card>
            <b-card-body style="padding-left: 30vh; padding-right: 30vh;">
                <b-row align-h="center">
                    <b-col align-v="stretch">
                        <h3 style="margin: 0;">
                            {{ registrationInfo.companyShortName }} </h3>
                        <h4>{{ registrationInfo.address }} <br/>
                            {{ registrationInfo.zip }} {{ registrationInfo.city }} <br/>
                            {{ $t('registration.tax-number') }} {{ registrationInfo.companyTaxNumber }}<br/>
                            {{ $t('registration.residential-id') }} {{ registrationInfo.companyId }}
                        </h4>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col align-v="stretch">
                        <validation-observer ref="observer" v-slot="{ invalid }">
                            <b-form @submit.prevent="onSubmit" id="registrationForm">
                                <h3>{{ $t('registration.data-entry-label') }}</h3>
                                <b-form-group :label="$t('registration.first-name')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model="merchant.firstName"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('registration.last-name')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model="merchant.lastName"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('registration.email')">
                                    <validation-provider rules="required|email"
                                                         v-slot="{ errors }">
                                            <b-form-input v-model="merchant.email"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('registration.phone')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model="merchant.phone"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <h3>{{ $t('registration.other-data-label') }}</h3>

                                <b-form-group :label="$t('registration.citizenship')">
                                    <el-select
                                        class="select-primary"
                                        style="width: 50%"
                                        size="small"
                                        v-model="merchant.citizenship">
                                        <el-option
                                            v-for="option in countryList"
                                            class="select-primary"
                                            :value="option.id"
                                            :label="option.name"
                                            :key="option.id">
                                        </el-option>
                                    </el-select>
                                </b-form-group>
                                <b-form-group :label="$t('registration.birth-date')">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <el-date-picker
                                            v-model="merchant.birthDate"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            :picker-options="dateOptions">
                                        </el-date-picker>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('registration.birth-place')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.birthCity"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('registration.birth-country')" >
                                    <el-select
                                        class="select-primary"
                                        style="width: 50%"
                                        size="small"
                                        v-model="merchant.birthCountry"
                                    >
                                        <el-option
                                            v-for="option in countryList"
                                            class="select-primary"
                                            :value="option.id"
                                            :label="option.name"
                                            :key="option.id">
                                        </el-option>
                                    </el-select>
                                </b-form-group>

                                <h4>{{ $t('registration.permanent-address-label') }}</h4>

                                <b-form-group :label="$t('registration.address')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.address"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('registration.zip')">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.zip"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('registration.city')">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.city"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <h4>{{ $t('registration.temporary-address-label') }}</h4>

                                <b-form-group :label="$t('registration.address')">
                                    <validation-provider v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.temporaryAddress"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <h3>{{ $t('registration.identification-label') }}</h3>

                                <b-form-group :label="$t('registration.document-number')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.idDocumentNumber"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('registration.document-issuer')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-model="merchant.idDocumentIssuer"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('registration.document-issue-date')">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <el-date-picker
                                            v-model="merchant.idDocumentDateOfIssue"
                                            type="date"
                                            :picker-options="docIssueDateOptions">
                                        </el-date-picker>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('registration.document-expiry')">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <el-date-picker
                                            v-model="merchant.idDocumentExpiry"
                                            type="date"
                                            :picker-options="docExpiryDateOptions">
                                        </el-date-picker>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group>
                                    <b-row>
                                        <b-col>
                                            <p-radio v-model="merchant.documentType" :label="identification_card" :value="identification_card">
                                                {{ $t('registration.personal-id') }}
                                            </p-radio>
                                            <p-radio v-model="merchant.documentType" :label="passport" :value="passport">
                                                {{ $t('registration.passport') }}
                                            </p-radio>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col v-if="merchant.documentType === identification_card">
                                            {{ $t('registration.personal-id-label') }}
                                        </b-col>
                                        <b-col v-if="merchant.documentType === passport">
                                            {{ $t('registration.passport-label') }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <validation-provider rules="required" v-slot="{ errors }">
                                                <ImageUploader
                                                    :upload-msg="$t('registration.upload-front')"
                                                    :max-error="$t('registration.already-uploaded')"
                                                    :clear-all="$t('registration.remove-image')"
                                                    :file-error="$t('registration.upload-invalid')"
                                                    max="1"
                                                    max-size="6"
                                                    @change="handleImagesFront"/>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </b-col>
                                        <b-col v-if="merchant.documentType === identification_card">
                                            <validation-provider rules="required"
                                                                 v-slot="{ errors }">
                                                <ImageUploader
                                                    :upload-msg="$t('registration.upload-back')"
                                                    :max-error="$t('registration.already-uploaded')"
                                                    :clear-all="$t('registration.remove-image')"
                                                    :file-error="$t('registration.upload-invalid')"
                                                    max="1"
                                                    max-size="6"
                                                    @change="handleImagesBack"/>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                           <!--     <b-form-group>
                                    <p-checkbox v-model="merchant.pio">{{ $t('registration.pio') }}</p-checkbox>
                                </b-form-group> -->
                                <br/>
                                <label v-if="invalid || !imagesLoaded" class="col-form-label" style="color: red">{{ $t('registration.fill-all-data') }}</label>
                                <br/>
                                <b-button class="btn btn-info" name="submitButton" id="registerButton" :disabled="invalid || !imagesLoaded" type="submit">
                                    {{ $t('registration.submit') }}
                                </b-button>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>

</template>

<script>
import Parallax from 'vue-parallaxy'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
import i18n from "../i18n";
import {DatePicker, Option, Select, Slider} from 'element-ui';
import {countries} from '@/data/countries';
import Constants from 'frontend_common/src/constants/globalConstants';
import ImageUploader from '@/components/ImageUploader';
import swal from "sweetalert2";
// import UploadImages from 'vue-upload-drop-images';
// import * as BlinkIDSDK from "@microblink/blinkid-in-browser-sdk";

extend('required', {
    ...required,
    message: (_, values) => i18n.t('common.required', values)
});

extend('email', {
    ...email,
    message: (_, values) => i18n.t('common.regex', values)
});

export default {
    name: "Registration",
    components: {
        Parallax,
        ValidationProvider,
        ValidationObserver,
        [DatePicker.name]: DatePicker,
        [Option.name]: Option,
        [Select.name]: Select,
        [Slider.name]: Slider,
        ImageUploader
        // UploadImages
    },
    data() {
        return {
            merchant: {
                legalOwner: false,
                ownershipPercentage: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                citizenship: 'SI',
                birthCity: null,
                birthCountry: 'SI',
                birthDate: null,
                address: null,
                zip: null,
                city: null,
                temporaryAddress: null,
                documentType: null,
                pio: false,
                fileFront: null,
                fileBack: null,
                taxNumber: null,
                idDocumentNumber: null,
                idDocumentIssuer: null,
                idDocumentExpiry: null,
                idDocumentDateOfIssue: null
            },
            dateOptions: {
                useCurrent: true,
                showClose: true,
                locale: 'sl',
                disabledDate:(time) => {
                    return time > new Date();
                }
            },
            docExpiryDateOptions: {
                useCurrent: true,
                showClose: true,
                locale: 'sl',
                disabledDate:(time) => {
                    return time < new Date();
                }
            },
            docIssueDateOptions: {
                useCurrent: true,
                showClose: true,
                locale: 'sl',
                disabledDate:(time) => {
                    return time > new Date();
                }
            },
            countryList: countries
        }
    },
    computed: {
        registrationInfo() {
            return this.$store.getters.getRegistrationInfo;
        },
        identification_card() {
            return Constants.DOCUMENT_TYPE_PERSONAL_ID;
        },
        passport() {
            return Constants.DOCUMENT_TYPE_PASSPORT;
        },
        imagesLoaded() {
            if(this.merchant.documentType === Constants.DOCUMENT_TYPE_PERSONAL_ID) {
                if(this.merchant.fileFront === null || this.merchant.fileBack === null) return false;
                else return true;
            } else {
                if(this.merchant.fileFront === null) return false;
                else return true;
            }
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
            let taxNumber = this.registrationInfo.taxNumber;
            if (taxNumber === null || taxNumber === 'undefined') {
                taxNumber = this.merchant.taxNumber;
            }

            // Check authorization
            let authQuery = {
                'taxId': this.registrationInfo.companyTaxNumber,
                'representativeTaxId': taxNumber,
                'certIssuerCn': this.registrationInfo.issuerCn,
                'certSerialNumber': this.registrationInfo.serialNumber,
                'email': this.merchant.email
            };
            this.$store.dispatch('checkAuthorization', authQuery)
                .then((response) => {
                    if (response.authorized) {
                        this.$store.commit('setIsAuthorized', true);
                        this.$store.commit('setMerchant', this.merchant);
                        //router.push({ name: 'user', params: { userId: '123' } })
                        // this.$router.push('/home/confirmRegistration');
                        this.$router.push('/home/legalOwnerInput');
                    } else {
                        this.$store.commit('setIsAuthorized', false);
                        this.showTaxNumberInput = true;
                        swal.fire({
                            title: this.$t('iban-input.verify-tax-number-fail'),
                            confirmButtonText: 'OK',
                            buttonsStyling: true
                        })

                        // this.$store.dispatch('verifyTaxNumbers')
                        //     .then((response) => {
                        //         if (response.code === 0) {
                        //             // Redirect to registration page
                        //             this.$router.push('/registration');
                        //         } else if (response.code === 564) {
                        //             this.showTaxNumberInput = true;
                        //
                        //             swal.fire({
                        //                 title: 'Vstopili ste z digitalnim potrdilom SIGEN-CA. Ker vaše digitalno potrdilo SIGEN-CA\n' +
                        //                     '\tne vsebuje davčne številke, vas prosimo, da davčno številko vpišete sami. Vaše\n' +
                        //                     '\tdigitalno potrdilo in davčno številko bomo preverili na spletnem servisu SIGEN-CA.',
                        //                 type: 'warning',
                        //                 confirmButtonText: 'OK',
                        //                 confirmButtonClass: 'btn btn-danger btn-fill',
                        //                 buttonsStyling: false
                        //             })
                        //             // swal -> sigenca - vpiš tax nr
                        //         } else {
                        //             this.showTaxNumberInput = true;
                        //             swal.fire({
                        //                 title: 'Spletni servis SIGEN-CA ni uspel preveriti vaše davčne številke.</span><br/>\n' +
                        //                     '<small>Prosimo preverite vpisano davčno številko in poizkusite znova.',
                        //                 type: 'warning',
                        //                 confirmButtonText: 'OK',
                        //                 confirmButtonClass: 'btn btn-danger btn-fill',
                        //                 buttonsStyling: false
                        //             })
                        //             //Spletni servis SIGEN-CA ni uspel preveriti vaše davčne številke.</span><br/>
                        //             //<small>Prosimo preverite vpisano davčno številko in poizkusite znova.
                        //         }
                        //
                        //     })
                        //     .catch(error => {
                        //         this.$store.commit('setError', error);
                        //         // TODO FIXME XXX handle different VERIFY TAX NUMBER error codes!
                        //     })
                        //     .finally(() => {
                        //     });
                    }
                })
                .catch(error => {
                    this.$store.commit('setError', error);
                    // TODO FIXME XXX handle different AUTH CHECK error codes!
                })
                .finally(() => {
                });


        },
        handleImagesFront(files) {
            if (files.length > 0) {
                let _merchant = this.merchant;
                let reader = new FileReader();
                reader.onload = function (readerEvt) {
                    _merchant.fileFront = readerEvt.target.result.split(',')[1];
                };
                reader.readAsDataURL(files[0]);
            } else {
                this.merchant.fileFront = null;
            }
        },
        handleImagesBack(files) {
            if (files.length > 0) {
                let _merchant = this.merchant;
                let reader = new FileReader();
                reader.onload = function (readerEvt) {
                    _merchant.fileBack = readerEvt.target.result.split(',')[1];
                };
                reader.readAsDataURL(files[0]);
            } else {
                this.merchant.fileBack = null;
            }
        }
    },
    mounted() {
        this.merchant.documentType = Constants.DOCUMENT_TYPE_PERSONAL_ID;
    }
}
</script>

<style scoped>

</style>